<template>
    <div id="app">
        <Header></Header>
        <main class="adjuster" v-if="code === 0">
            <div class="card">
                <div class="title">提交 #{{ id }}</div>
                <a-divider class="divider"></a-divider>
                <div>
                    <Status :status="status"></Status>
                    由<user-link v-bind="user"></user-link>
                    提交于 {{ formatTime(submittime) }}
                </div>
            </div>
            <div class="card">
                <div class="renderText" v-html="content"></div>
            </div>
            <div class="title">
                {{ title }}
            </div>
            <div class="task-detail" v-html="content"></div>
        </main>
        <main class="adjuster" v-else>
            提交不存在或者没有权限查看
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '../components/Header.vue';
import Status from '../components/Status.vue';
import Footer from '@/components/Footer';
import { highlight } from '../utils';
import { formatTime, getSSRdata } from '../../../utils/utils';
import UserLink from '@/components/UserLink.vue';

export default {
    data: () => ({
        code: 0,
        id: 0,
        task: {
            id: 0,
            title: 0,
        },
        user: {},
        status: "unjudge",
        script: "",
        submittime: 0,
    }),
    created() {
        const { code, id, task, user, status, script, submittime } = getSSRdata("submission");
        const coloredscript = highlight(script, "js");
        this.code = code;
        this.id = id;
        this.task = task;
        this.user = user;
        this.status = status;
        this.script = coloredscript;
        this.submittime = submittime;

        document.title = `提交#${ id } - H5CodeLab`;
    },
    mounted() {
    },
    methods: {
        formatTime,
    },
    components: {
        Header, Footer,
        Status,
        UserLink,
    }
}
</script>

<style lang="less">
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.adjuster {
    margin: 0px auto;
    flex-grow: 1;
    position: relative;
    width: 100%;
}
.brench {
    height: 100%;
    position: absolute;
}
.task-text {
    text-align: left;
    padding: 5px;
}
.title {
    font-size: 20px;
    margin-bottom: 2px;
}
</style>